// @ts-nocheck - TODO: Fix TypeScript errors systematically

/**
 * SplitPanel.tsx - SplitPanel - Resizable split view component
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React, { useState, useRef, useEffect } from 'react';

export const SplitPanel = ({
  children,
  className = '',
  direction = 'horizontal', // 'horizontal' or 'vertical'
  defaultSize = 50, // Percentage
  minSize = 10,
  maxSize = 90,
  persistent = true,
  storageKey = 'split-panel',
  onResize
}) => {
  const [size, setSize] = useState(() => {
    if (persistent) {
      const saved = localStorage.getItem(storageKey);
      return saved ? parseFloat(saved) : defaultSize;
    }
    return defaultSize;
  });

  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e) => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();

      let newSize;
      if (direction === 'horizontal') {
        const x = e.clientX - rect.left;
        newSize = (x / rect.width) * 100;
      } else {
        const y = e.clientY - rect.top;
        newSize = (y / rect.height) * 100;
      }

      // Clamp to min/max
      newSize = Math.max(minSize, Math.min(maxSize, newSize));
      setSize(newSize);

      // Save to localStorage
      if (persistent) {
        localStorage.setItem(storageKey, newSize.toString());
      }

      onResize?.(newSize);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, direction, minSize, maxSize, persistent, storageKey, onResize]);

  const [firstChild, secondChild] = React.Children.toArray(children);

  const firstStyle = direction === 'horizontal'
    ? { width: `${size}%` }
    : { height: `${size}%` };

  const secondStyle = direction === 'horizontal'
    ? { width: `${100 - size}%` }
    : { height: `${100 - size}%` };

  return (
    <div 
      ref={containerRef}
      className={`split-panel split-${direction} ${isDragging ? 'dragging' : ''} ${className}`}
    >
      <div className="split-pane split-pane-first" style={firstStyle}>
        {firstChild}
      </div>

      <div 
        className={`split-divider split-divider-${direction}`}
        onMouseDown={handleMouseDown}
      >
        <div className="split-divider-handle" />
      </div>

      <div className="split-pane split-pane-second" style={secondStyle}>
        {secondChild}
      </div>
    </div>
  );
};

export default SplitPanel;
